module.exports = __webpack_public_path__ + "img/company.eddd8753.svg";